export function apiGet (vm, url, params, onSuccess, onError, onFinish) {
  var obj = { params: params }
  if (params.octopus) {
    url          = `${process.env.API_OCTOPUS}${url}`
    params.token = localStorage.getItem('tokenOctopus')
    // console.log('url:', url)
  } else params.token = localStorage.getItem('token')
  params.empresa = process.env.EMPRESA
  vm.axios.get(url, obj).then(function (response) {
    var data = response.data
    data.status = +data.status;
    // console.log('data:', data)
    if (data.status === -1) {
      // No se ha logueado
      // localStorage.setItem('token', '')
      // window.location.href = '/'
    } else if (data.status === 0) {
      onError(data)
      if (onFinish) onFinish()
    } else {
      onSuccess(data)
      if (onFinish) onFinish()
    }
  }).catch(function (error) {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiGetExcel (vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    responseType: 'arraybuffer',
    params      : params
  }

  if (params.octopus) {
    var api = ''
    api = process.env.API_OCTOPUS
    url = api + url
  }

  params.empresa = process.env.EMPRESA

  if (params.octopus) params.token   = localStorage.getItem('tokenOctopus')
  else params.token   = localStorage.getItem('token')

  vm.axios.get(url, obj).then((response) => {
    var data = response.data
    onSuccess(data)
    if (onFinish) onFinish()
  }).catch((error) => {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiUpload (vm, url, params, onSuccess, onError, onFinish) {
  var obj = params

  params.empresa = process.env.EMPRESA
  params.token   = localStorage.getItem('token')

  vm.axios.post(url, obj).then((response) => {
    var data = response.data
    data.status = +data.status;
    console.log('response:', response)
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '')
      window.location.href = '/'
    } else if (data.status === 0) {
      onError(data)
      if (onFinish) onFinish()
    } else {
      onSuccess(data)
      if (onFinish) onFinish()
    }
  }).catch((error) => {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiPost (vm, url, params, onSuccess, onError, onFinish) {
  var obj = params
  if (params.octopus) {
    url               = `${process.env.API_OCTOPUS}${url}`
    params.token      = localStorage.getItem('tokenOctopus')
  } else params.token = localStorage.getItem('token')
  params.empresa = process.env.EMPRESA

  vm.axios.post(url, obj).then(function (response) {
    var data = response.data
    data.status = +data.status;
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '')
      window.location.href = '/'
    } else if (data.status === 0) {
      onError(data)
      if (onFinish) onFinish()
    } else {
      onSuccess(data)
      if (onFinish) onFinish()
    }
  }).catch(function (error) {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiPut (vm, url, params, onSuccess, onError, onFinish) {
  var obj = params

  params.empresa = process.env.EMPRESA
  params.token   = localStorage.getItem('token')

  vm.axios.put(url, obj).then((response) => {
    var data = response.data
    data.status = +data.status;
    console.log('response:', response)
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '')
      window.location.href = '/'
    } else if (data.status === 0) {
      onError(data)
      if (onFinish) onFinish()
    } else {
      onSuccess(data)
      if (onFinish) onFinish()
    }
  }).catch((error) => {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiDelete (vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    params: params
  }

  params.empresa = process.env.EMPRESA
  if (params.octopus) {
    url               = `${process.env.API_OCTOPUS}${url}`
    params.token      = localStorage.getItem('tokenOctopus')
  } else params.token = localStorage.getItem('token')

  vm.axios.delete(url, obj).then((response) => {
    var data = response.data
    data.status = +data.status;
    console.log('response:', response)
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '')
      window.location.href = '/'
    } else if (data.status === 0) {
      onError(data)
      if (onFinish) onFinish()
    } else {
      onSuccess(data)
      if (onFinish) onFinish()
    }
  }).catch((error) => {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiUploadWithParams (vm, url, body, params, onSuccess, onError, onFinish) {
  var obj = body

  body.empresa    = process.env.EMPRESA
  params.empresa  = process.env.EMPRESA.toLowerCase() || 'datacont'
  params.app      = 'selfservice'
  if (params.octopus) {
    url               = `${process.env.API_OCTOPUS}${url}`
    params.token      = localStorage.getItem('tokenOctopus')
  } else params.token = localStorage.getItem('token')

  vm.axios.post(url, obj, { params }).then((response) => {
    console.Console
    var data = response.data
    data.status = +data.status;
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '')
      window.location.href = '/'
    } else if (data.status === 0) {
      onError(data)
      if (onFinish) onFinish()
    } else {
      onSuccess(data)
      if (onFinish) onFinish()
    }
  }).catch((error) => {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function notify (vm, type, title, text) {
  vm.$notify({
    title   : title,
    text    : text,
    position: 'bottom right',
    type    : type
  });
}



// WEBPACK FOOTER //
// ./src/util/general.js